import { NO_CONTENT } from 'shared/consts/codes'
import { type ServiceParameters } from 'shared/services/api/commonTypes'

import BackendAPIService from './BackendAPIService'

interface ICustomerDataService {
  getDateOfBirthURL: () => string
  getEmailURL: () => string
  changeDateOfBirth: (dateOfBirth: string) => Promise<boolean>
  changeEmail: (email: string, password: string) => Promise<boolean>
}

class CustomerDataService
  extends BackendAPIService
  implements ICustomerDataService
{
  constructor(params: ServiceParameters) {
    super({ apiVersion: 'v1', ...params })
  }

  public getDateOfBirthURL(): string {
    return `/customer/${this.apiVersion}/${this.tenantPath}/dateOfBirth`
  }

  public getEmailURL(): string {
    return `/customer/${this.apiVersion}/${this.tenantPath}/changeEmail`
  }

  public getEmailConfirmationURL(token: string): string {
    return `/customer/${this.apiVersion}/${this.tenantPath}/email/${token}`
  }

  async changeDateOfBirth(dateOfBirth: string): Promise<boolean> {
    const { status } = await this.patch(this.getDateOfBirthURL(), {
      dateOfBirth,
    })
    return status === NO_CONTENT
  }

  async changeEmail(email: string, password: string): Promise<boolean> {
    const { status } = await this.post(this.getEmailURL(), { email, password })
    return status === NO_CONTENT
  }

  async changeEmailConfirmation(token: string): Promise<boolean> {
    const emailConfirmationURL = this.getEmailConfirmationURL(
      encodeURIComponent(token)
    )
    const { status } = await this.patch(emailConfirmationURL, {})
    return status === NO_CONTENT
  }
}

export default CustomerDataService
